import React, { Component } from "react"
import Topnav from "../../components/topnav/topnav";
import { connect } from "react-redux"
import Footer from "../../components/footer/footer";
import { Row, notification, Col, Button, Spin, Icon, message } from "antd";
import { CLOUD_FUNCTION } from "../../../../../config/fbConfig"
import Axios from "axios"
import ReactGA from 'react-ga';
import { bindActionCreators } from "redux"
import { changePlan, getCards, saveCard } from "../../../../core/actions/auth"
import { Elements, StripeProvider } from 'react-stripe-elements';
import { Helmet } from "react-helmet";
import { basicPlanPrice, proPlanPrice } from "../../../../../config/fbConfig"
import moment from "moment"
import { stripe_api_key } from "../../../../../config/fbConfig"
import Addcard from "../../components/profile/addcard";
const antIcon = <Icon type="loading" spin />;
const openNotificationWithIcon = (type) => {
  notification[type]({
    message: 'Notification',
    description: 'Congratulations! your plan has been updated successful.',
  });
};
const openNotificationWithIcon2 = (type) => {
  notification[type]({
    message: 'Notification',
    description: 'Please add a payment card to your account',
  });
};
class Changeplan extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pricingPlans: [],
      toggleName: "",
      switchingPlan: false,
      addCardModal: false,
      preload: true
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        preload: false
      })
    }, 300);
  }

  componentWillMount() {
    var { profile, fireAuth } = this.props
    this.props.getCards(fireAuth.uid)
    this.initializePlan(profile)
  }

  componentWillReceiveProps(nextProps) {
    var { profile } = nextProps
    this.initializePlan(profile)
    if (nextProps.auth.changePlanSuccess === true) {
      openNotificationWithIcon('success')
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }

  initializePlan = (profile) => {
    var plans = [
      { id: 1, title: 'free', package: "Monthly", price: 0, users: 4, storage: 2 },
      { id: 2, title: 'basic', package: "Monthly", price: basicPlanPrice, users: 8, storage: 5 },
      { id: 3, title: 'pro', package: "Yearly", price: proPlanPrice, users: 12, storage: 7 },
    ]
    if (profile.isLoaded) {
      var planIndex = plans.findIndex((plan) => profile.plan === plan.title)
      var toggleName = planIndex === (plans.length - 1) ? "Downgrade " : "Upgrade "
      var pricingPlans = plans.filter((plan) => (profile.plan !== plan.title))
      this.setState({ pricingPlans, toggleName })
    } else {
      this.setState({ pricingPlans: [] })
    }
  }

  upgrade = (plan) => {
    var { profile } = this.props

    if (this.props.cards.length === 0 && plan.title !== "free") {
      openNotificationWithIcon2("error");
      this.setState({ switchingPlan: false, addCardModal: true });
      return false
    }
    this.setState({ switchingPlan: true })
    var { profile, cards } = this.props;
    if (cards.length === 0 && plan.title !== "free") {
      openNotificationWithIcon2("error");
      this.setState({ switchingPlan: false });
      return false
    }
    if (plan.title === "free") {
      var current_period_end = profile.current_period_end ? profile.current_period_end : moment().unix();
    } else if (plan.title === "basic") {
      var current_period_end = profile.current_period_end ? moment.unix(profile.current_period_end).add('1', 'M').unix() : moment().add('1', 'M').unix();
      if (profile.trial.plan && profile.trial.reset === false) {
        var unusedDays = moment.unix(profile.current_period_end).diff(moment(), 'days')
        current_period_end = moment().add('1', 'M').add(unusedDays, 'days').unix()
      }
    }
    else if (plan.title === "pro") {
      var current_period_end = profile.current_period_end ? moment.unix(profile.current_period_end).add('1', 'Y').unix() : moment().add('1', 'Y').unix();
      if (profile.trial.plan && profile.trial.reset === false) {
        var unusedDays = moment.unix(profile.current_period_end).diff(moment(), 'days')
        current_period_end = moment().add('1', 'Y').add(unusedDays, 'days').unix()
      }

    }
    Axios.post(`${CLOUD_FUNCTION}/api/change_plan`, { plan: plan.title, current_period_end, profile })
      .then((res) => {
        console.log(res)
        if (res.data.message) {
          var subscriptionId = "";
          if (res.data.subscription) subscriptionId = res.data.subscription.id
          var data = {
            subscription: {
              customerId: profile.subscription.customerId,
              subscriptionId
            },
            current_period_end,
            status: {
              completed: true
            },
            plan: plan.title,
            trial: { plan: profile.plan === "free" ? plan.title : profile.plan, endAt: profile.current_period_end, reset: false }
          }
          //reset
          if (plan.title === "free") data.trial.reset = true
          this.props.changePlan(profile.uid, data)
          window.fbq('track', 'Purchase', {
            value: plan.price,
            currency: 'USD',
          });
          ReactGA.event({
            category: 'User',
            action: 'Purchase',
            label: 'User Interaction',
            value: plan.price
          });
        } else if (res.data.error) {
          message.error(res.data.error.message)
        }
        this.setState({ switchingPlan: false })

        // window.location.assign('/');
      }).catch((error) => {
        console.log(error)
        this.setState({ switchingPlan: false })
      })
  }
  render() {
    var { switchingPlan, toggleName, preload } = this.state;
    const {from} = this.props
    return (
      !preload ? this.props.profile.isLoaded ?
        <div className={`pricing change-plan ${from ? 'from-dash' : null }`}>
          {from?null:  <Helmet>
            <title>Change plan</title>
          </Helmet>}
          <Spin tip="switching plan" spinning={switchingPlan} indicator={antIcon}>
          {from?null:   <Topnav {...this.props} />}
        
            <div className="xcontent">
              {from?
                <Row type="flex">
                <Col span={24}>
                  <div className="xtitle">
                    <h3 className="open-sans2"> {toggleName} your Package </h3>
                  </div>
                </Col>
              </Row>:<Row type="flex" justify="center">
                <Col sm={24} lg={{ span: 16 }}>
                  <div className="xtitle">
                    <h1 className="open-sans2"> {toggleName} your Package </h1>
                  </div>
                </Col>
              </Row>}
              <Row type="flex" justify={from?null:"center"}>
                {this.state.pricingPlans.map((plan, key) => (
                  <Col className="no-padding" key={key} xs={24} sm={24} md={from ? 12 : plan.title === "pro" ? 7 : 6} lg={from ? 12 : plan.title === "pro" ? 8 : 6}>
                    <div className="xbox">
                      <div className={`pricing-card ${plan.title}`}>
                        <div className="header">
                          {plan.title === "pro" ? <h3 className='open-sans2'>Professional</h3>
                            : <h4 className='open-sans2'>{plan.title}</h4>
                          }
                          {plan.title === "pro" &&
                            <p>Learn the best JavaScript tools and frameworks from industry pros.
                                 </p>}
                          {plan.title === "basic" && <p>Learn JavaScript like your career depends on it</p>
                          }
                          {plan.title === "free" && <p>
                            Ready to get Started? Learn something new today
                                 </p>}
                          <p >Starting at</p>
                          <p className="price">${plan.price}<span>/{plan.title === "pro" ? "yr" : "mo"}</span></p>
                        </div>
                        <center><Button onClick={() => this.upgrade(plan)}>Select Package</Button></center>
                        <hr />
                        <div className="xbody">
                          <p>{plan.users} users included</p>
                          <p>{plan.storage} GB of storage</p>
                          <p>Email Support</p>
                          <p>Help center access</p>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}


              </Row>
            </div>
            {this.state.addCardModal && <StripeProvider
              apiKey={stripe_api_key}
            >
              <Elements>
                <Addcard
                  auth={this.props.auth}
                  profile={this.props.profile}
                  visible={this.state.addCardModal}
                  saveCard={this.props.saveCard}
                  hideBtn={true}
                />
              </Elements>
            </StripeProvider>}
           {from?null: <Footer />}
          </Spin>
        </div>
        : null
        :
        <div className="x-loader">
          <Icon type="loading" style={{ fontSize: 60 }} spin />
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    fireAuth: state.firebase.auth,
    profile: state.firebase.profile,
    cards: state.cards.cards
  }
}
const mapDispatchToProps = (dispatch) => bindActionCreators({
  changePlan,
  getCards,
  saveCard,
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Changeplan)